import React from 'react';
import { MinimalistLanding } from './MinimalistLanding';

export const CustomerSupportDemo: React.FC = () => {
  return <MinimalistLanding />;
};